
  import { Vue, Component, Prop } from "vue-property-decorator";

  import Chip from "@/components/filters/Chip.vue";
  import getPostedAtLabel from "@/helpers/postings/getPostedAtLabel";
  import getStatusLabel from "@/helpers/postings/getStatusLabel";
import BadgeColor from "@/entities/BadgeColor";
import Badge from "@/components/common/Badge.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreCustom.vue";
  import { Posting_Industry, Posting_Skill,  } from "@/generated/graphql";
  import {  NO_INFORMATION } from "@/data/placeholders";
import ItemsRenderer from "@/components/ItemsRenderer.vue";

  @Component({
    components: {

      ItemChipsWithMore,
      Chip,
      Badge,
      ItemsRenderer
    },
  })
  export default class PostingDetails extends Vue {
    @Prop({ type: String, default: undefined }) readonly description?: string;
    @Prop({ type: Array, default: () => [] }) readonly industries!: Posting_Industry[];
    @Prop({ type: Array, default: () => [] }) readonly skills!: Posting_Skill[];
    @Prop({ type: Boolean, default: false }) readonly status!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isPublic!: boolean;

    placeholder: string = NO_INFORMATION;

    get currentStatus(): string {
      return getStatusLabel(this.status);
    }
  get badgeData(): { value: string, color: string, class?: string } {
    if (!this.status) {
      return {
        value: "Inactive",
        color: BadgeColor.WARNING,
        class: 'w-max-content'
      }
    }
    if (this.status) {
      return {
        value: "Active",
        color: BadgeColor.SUCCESS,
        class: 'text-badge w-max-content'
      }
    }
  }
    get postedAt(): string {
      return getPostedAtLabel(this.isPublic);
    }

  get  getSkils(){
return this.skills.map(s => {
  if (s.skill) {
    return s.skill
  }
  return s
})
    }
  get  getIndustries(){
return this.industries.map(s => {
  if (s.industry) {
    return s.industry
  }
  return s
})
    }
  }
